import type { HttpErrorResponse } from '@angular/common/http';

import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';

import type { IUserResetPasswordParams } from '../../interfaces/user/user.interface';

import { AlertService } from '../../services/alert.service';
import { UsersService } from '../../services/users/users.service';
import { EMAIL_REGEX } from '../../variables/variables';

@Component({
  selector: 'password-reset-from',
  templateUrl: './password-reset-from.component.html',
  styleUrls: ['./password-reset-from.component.scss'],
})
export class PasswordResetFromComponent implements OnInit {
  resetPasswordForm: UntypedFormGroup;
  isLoading = false;
  isPasswordResetSuccessful = false;

  @Output() submitEmitter = new EventEmitter<boolean>();
  subscriptions: Subscription = new Subscription();

  constructor(
    private usersService: UsersService,
    private alertService: AlertService,
  ) {}

  ngOnInit() {
    this.resetPasswordForm = new UntypedFormGroup({
      email: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern(EMAIL_REGEX),
      ]),
      pin: new UntypedFormControl(null, [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4),
      ]),
    });
  }

  onSubmit() {
    const resetPasswordFormValue: IUserResetPasswordParams = {
      ...this.resetPasswordForm.value,
      requestedBy: 'Admin',
    };

    this.resetPasswordForm.disable();
    this.isLoading = true;
    this.submitEmitter.emit(this.isLoading);

    this.subscriptions.add(
      this.usersService.resetPassword(resetPasswordFormValue).subscribe({
        next: () => {
          this.isLoading = false;
          this.submitEmitter.emit(this.isLoading);
          this.isPasswordResetSuccessful = true;
        },
        error: (error: HttpErrorResponse | string) => {
          this.alertService.error(error);
          this.isLoading = false;
          this.submitEmitter.emit(this.isLoading);
          this.resetPasswordForm.enable();
        },
      }),
    );
  }
}
